import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const UserModal = ({ open, onOpenChange, editUser, userForm, setUserForm, onSave }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-800 border-slate-700 text-white" data-testid="user-modal">
        <DialogHeader>
          <DialogTitle>{editUser ? "Modifier l'utilisateur" : "Ajouter un utilisateur"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Nom complet</Label>
            <Input
              value={userForm.full_name}
              onChange={(e) => setUserForm({ ...userForm, full_name: e.target.value })}
              className="bg-slate-700 border-slate-600"
              data-testid="user-fullname-input"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Nom d'utilisateur *</Label>
              <Input
                value={userForm.username}
                onChange={(e) => setUserForm({ ...userForm, username: e.target.value })}
                className="bg-slate-700 border-slate-600"
                data-testid="user-username-input"
              />
            </div>
            <div className="space-y-2">
              <Label>Code PIN (4-6 chiffres) *</Label>
              <Input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={6}
                value={userForm.pin}
                onChange={(e) => setUserForm({ ...userForm, pin: e.target.value.replace(/\D/g, "") })}
                className="bg-slate-700 border-slate-600 font-mono tracking-widest"
                placeholder="Ex: 1234"
                data-testid="user-pin-input"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Email (optionnel)</Label>
              <Input
                value={userForm.email}
                onChange={(e) => setUserForm({ ...userForm, email: e.target.value })}
                className="bg-slate-700 border-slate-600"
                data-testid="user-email-input"
              />
            </div>
            <div className="space-y-2">
              <Label>Rôle</Label>
              <Select value={userForm.role} onValueChange={(v) => setUserForm({ ...userForm, role: v })}>
                <SelectTrigger className="bg-slate-700 border-slate-600" data-testid="user-role-trigger">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-slate-800 border-slate-700">
                  <SelectItem value="server">Agent</SelectItem>
                  <SelectItem value="cuisinier">Cuisinier</SelectItem>
                  <SelectItem value="coach_jeux">Coach Jeux</SelectItem>
                  <SelectItem value="manager">Responsable des Opérations & Logistique</SelectItem>
                  <SelectItem value="admin">Administrateur</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          {/* 🆕 Fév 2026 — Champ mot de passe (admin peut définir/changer). */}
          <div className="space-y-2">
            <Label>
              Mot de passe {editUser ? <span className="text-slate-400 text-xs font-normal">(laisser vide pour ne pas changer)</span> : <span className="text-slate-500 text-xs font-normal">(optionnel — le PIN suffit)</span>}
            </Label>
            <Input
              type="password"
              value={userForm.password || ""}
              onChange={(e) => setUserForm({ ...userForm, password: e.target.value })}
              className="bg-slate-700 border-slate-600"
              placeholder={editUser ? "Nouveau mot de passe" : "Mot de passe"}
              autoComplete="new-password"
              data-testid="user-password-input"
            />
          </div>
          <Button
            onClick={onSave}
            className="w-full bg-red-500 hover:bg-red-600"
            data-testid="user-save-btn"
          >
            Enregistrer
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UserModal;
